export const orderProviderEnum = [
  { id: "", name: "All" },
  { id: "ecommerce", name: "Ecommerce" },
  { id: "sap", name: "SAP" },
  // { id: "crm", name: "CRM" },
];
